module.exports = __webpack_public_path__ + "assets/img/m_bdt_img5.c46e1dec.png";